import classNames from "classnames/dedupe";
import React, { ElementType, FC, useContext, ReactNode } from "react";

import { accordionContext } from "./AccordionContext";

export interface IAccordionTitleProps {
  /**
   * Sets a custom html element for this component
   *
   * @default 'div'
   */
  as?: ElementType;
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    root?: string;
  };
  children?: ReactNode;
}

const AccordionTitle: FC<IAccordionTitleProps> = ({
  as: Component = "div",
  classes,
  children,
  ...other
}) => {
  const context = useContext(accordionContext);

  const rootClasses = classNames("cursor-pointer", classes?.root);

  return (
    <Component
      data-testid="accordion-title"
      onClick={context.onToggle}
      className={rootClasses}
      {...other}
    >
      {children}
    </Component>
  );
};

export default AccordionTitle;
